import { render, staticRenderFns } from "./add-new-management-server.vue?vue&type=template&id=77b1b966&scoped=true"
import script from "./add-new-management-server.vue?vue&type=script&lang=js"
export * from "./add-new-management-server.vue?vue&type=script&lang=js"
import style0 from "./add-new-management-server.vue?vue&type=style&index=0&id=77b1b966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b1b966",
  null
  
)

export default component.exports